module.exports = __webpack_public_path__ + "img/20200102154208360截图20200102111631657.bd95cb0a.jpg";